import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/68_card_back_heart_cat/68_card_back_heart_cat"
 * Contains 1 texture(s)
 */
export class CardsBacks68CardBackHeartCatAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/68_card_back_heart_cat/68_card_back_heart_cat';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '68_heart_cat.png'
    ] as const;
}
